// Action Types
export const MEETING_LOADED_FROM_DB = 'meeting/meetingLoadedFromDb';
export const MEETING_ADDED_LOCALLY = 'meeting/meetingAddedLocally';
export const MEETING_CREATED_SUCCESS = 'meeting/meetingCreatedSuccess';
export const MEETING_SYNC_FAILED = 'meeting/meetingSyncFailed';
export const MEETING_PATCH_LOCAL = 'meeting/meetingPatchLocal';
export const MEETING_SET_HESTORY = 'meeting/SetMeetingsHistory';
export const MEETING_ONGOING_CLEAR = 'meeting/OngoingMeetingClear';

// Initial state: No group exists yet for the user.
const initialState = {
    ongoing: null,
    history: []
};

export function meeting(state = initialState, action) {
    switch (action.type) {
        case MEETING_ADDED_LOCALLY:
            return {
                ...state,
                ongoing: {
                    ...action?.payload,
                    syncStatus: 'pending'
                }
            }
        case MEETING_LOADED_FROM_DB:
            return {
                ...state,
                ongoing: action.payload
            }
        case MEETING_SET_HESTORY:
            return {
                ...state,
                history: action.payload
            }
        case MEETING_PATCH_LOCAL:
            if (state && state?.ongoing?.cacheId === action.payload.tempId) {

                return {
                    ...state,
                    ongoing: {
                        ...state?.ongoing,
                        ...action.payload
                    }
                }
            }
            return state
        case MEETING_SYNC_FAILED:
            return {
                ...state,
                ongoing: {
                    ...state?.ongoing,
                    ...action.payload,
                    syncStatus: 'error',
                }
            }
        case MEETING_CREATED_SUCCESS:
            if (state && state?.ongoing?.cacheId === action.payload.tempId) {
                return {
                    ...state,
                    ongoing: {
                        ...action.payload, // This is the full meeting object from the server
                        syncStatus: 'synced',
                        error: null,
                    }
                };
            }
            // If the ID doesn't match, it might be a stale update, so we ignore it.
            return state;
        case MEETING_ONGOING_CLEAR:
            // Clear the ongoing meeting state
            if (
                state?.ongoing?.cacheId === action.payload?.tempId ||
                state?.ongoing?.id+'' === action.payload?.id+''
            ) {
                return {
                    ...state,
                    ongoing: null
                };
            }
            return state;
        default:
            return state
    }
}